<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-toc-title">Table of Contents</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<a href="#/Text/AuthorNote">A Note From The Author</a>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<a href="#/Text/PartOne">PART I</a>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<a href="#/Text/Prologue">Prologue - The Reporter</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_01">Chapter 1 - Infamous</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_02">Chapter 2 - Out of the Ashes</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_03">Chapter 3 - Homeless Steve</a>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_04" title="Link target outside of Sample">Chapter 4 -The Experiments</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_05" title="Link target outside of Sample">Chapter 5 - The One-Eyed Man</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_06" title="Link target outside of Sample">Chapter 6 - Connecting the Dots</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_07" title="Link target outside of Sample">Chapter 7 - Rogue Messiah</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_08" title="Link target outside of Sample">Chapter 8 - Starfished</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_09" title="Link target outside of Sample">Chapter 9 - The Sound of Silence</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_10" title="Link target outside of Sample">Chapter 10 - The Fog Man</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/PartTwo" title="Link target outside of Sample">PART II</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_11" title="Link target outside of Sample">Chapter 11 - Norris</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_12" title="Link target outside of Sample">Chapter 12 -The Regulator</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_13" title="Link target outside of Sample">Chapter 13 - Highwayman’s Second Wave</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_14" title="Link target outside of Sample">Chapter 14 – Road Trip</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_15" title="Link target outside of Sample">Chapter 15 - Escape</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_16" title="Link target outside of Sample">Chapter 16 - Run for the River</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_17" title="Link target outside of Sample">Chapter 17 – The Fug Game</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_18" title="Link target outside of Sample">Chapter 18 – Maxwell</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_19" title="Link target outside of Sample">Chapter 19 – Gifts</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_20" title="Link target outside of Sample">Chapter 20 – Hot Brown</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/PartThree" title="Link target outside of Sample">PART III</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_21" title="Link target outside of Sample">Chapter 21 – Dick 101</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_22" title="Link target outside of Sample">Chapter 22 – Into the Third Room</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_23" title="Link target outside of Sample">Chapter 23 – Car Trouble</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_24" title="Link target outside of Sample">Chapter 24 – Beating the Bushes</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_25" title="Link target outside of Sample">Chapter 25 – Cat Food Man</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_26" title="Link target outside of Sample">Chapter 26 – Devil’s Workshop</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_27" title="Link target outside of Sample">Chapter 27 – Lawyer Bob</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_28" title="Link target outside of Sample">Chapter 28 – MacDonald Triad</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_29" title="Link target outside of Sample">Chapter 29 – Three Acts</span>
</div>
<div class="sgc-toc-level-1"><span href="#/Text/Epilogue" title="Link target outside of Sample">Epilogue</span><br/></div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Notes" title="Link target outside of Sample">Notes</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Afterword" title="Link target outside of Sample">Afterword</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Acknowledgments" title="Link target outside of Sample">Acknowledgments</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?651aa66e